const ShowDetails = ({ showDetails, setShowDetails }) => {
  return (
    <div className="custom-control custom-checkbox pt-1">
      <input
        type="checkbox"
        className="custom-control-input"
        checked={showDetails}
        onChange={(e) => setShowDetails(e.target.checked)}
        id="showDetails"
      />
      <label className="custom-control-label" htmlFor="showDetails">
        جزئیات بیشتر
      </label>
    </div>
  );
};

export default ShowDetails;
